import { useOutletContext } from 'react-router-dom';

import { InventoryBlueprintTypeQuery } from './__generated__/index.graphql';

type LayoutData = {
  blueprints: NonNullable<
    InventoryBlueprintTypeQuery['revealableCardCampaign']
  >['myBlueprintCards']['nodes'];
  currentIndex: number;
  setCurrentIndex: (index: number | ((index: number) => number)) => void;
  nextCard: () => void;
  setShowSummary: (show: boolean) => void;
  currentUser: InventoryBlueprintTypeQuery['currentUser'];
  loading: boolean;
  environment?: string;
  cardRotationY?: number;
};

export const useMyCardsRevealableCardsTypeLayoutData = () => {
  return useOutletContext<LayoutData>();
};
